import fetch from "auth/FetchInterceptor";

const CouponService = {};

CouponService.getCoupons = function () {
  return fetch({
    url: "/coupons/",
    method: "get",
  });
};

CouponService.getCoupon = function (couponId) {
  return fetch({
    url: `/coupons/${couponId}`,
    method: "get",
  });
};

CouponService.addCoupon = function (coupon) {
  return fetch({
    url: "/coupons/",
    method: "post",
    data: coupon,
  });
};

CouponService.updateCoupon = function (data, couponId) {
  return fetch({
    url: `/coupons/${couponId}/`,
    method: "put",
    data: data,
  });
};

CouponService.deleteCoupon = function (couponId) {
  return fetch({
    url: `/coupons/${couponId}`,
    method: "delete",
  });
};

export default CouponService;
